export default {
  fetchingData: {
    id: 'listings-listing_detail-similar_listing-fetching_data',
    defaultMessage: 'We are fetching the data...',
  },
  similarListingForProduct: {
    id: 'listings-listing_detail-similar_listing-similar_listing_for_product',
    defaultMessage: 'Similar listing for this product',
  },
  SKU: {
    id: 'listings-listing_detail-similar_listing-sku',
    defaultMessage: 'SKU',
  },
  appearance: {
    id: 'listings-listing_detail-similar_listing-appearance',
    defaultMessage: 'Appearance',
  },
  stock: {
    id: 'listings-listing_detail-similar_listing-stock',
    defaultMessage: 'Stock',
  },
  viewButton: {
    id: 'listings-listing_detail-similar_listing-view_button',
    defaultMessage: 'View',
  },
  noResults: {
    id: 'listings-listing_detail-similar_listing-no_results',
    defaultMessage: 'There is no similar listings for this product',
  },
}
